import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Session } from "../utils/session";

export default function Phadsheet() {

  const navigate = useNavigate();
  const location = useLocation();

  const { sheetName, workspaceId } = location.state || {};

  const [showModal, setShowModal] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [form, setForm] = useState({
    docID: "",
    patientName: "",
    doctorName: "",
    vendor: "",
    reportType: "",
    reportSubtype: "",
    dob: "",
    dol: "",
    gender: "",
    scribedBy: "",
    upload: "",
    qc: "",
    chekedInPortal: "",
    timeIn: "",
    caseType: ""
  });

  // 🔹 Protect Route
  useEffect(() => {
    if (!location.state?.fromAddCard) {
      navigate("/dailytask");
    }
  }, [location, navigate]);

  // 🔹 Load Tabs
  useEffect(() => {

    if (!sheetName) return;

    fetch(
      `${API_BASE_URL}/api/GoogleSheet/tabs?sheetName=${encodeURIComponent(sheetName)}`,
      {
        headers: {
          Authorization: `Bearer ${Session.getToken()}`
        }
      }
    )
      .then(res => res.json())
      .then(data => setTabs(Array.isArray(data) ? data : []))
      .catch(err => console.error("Tab load error:", err));

  }, [sheetName]);

  // 🔹 Disable Scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => document.body.style.overflow = "auto";
  }, []);

  // 🔹 Handle Change
  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 🔹 Close
  const closeModal = () => {
    setShowModal(false);
    navigate(-1);
  };
  useEffect(() => {

    fetch(`${API_BASE_URL}/api/GoogleSheet/doctors-list`, {
      headers: {
        Authorization: `Bearer ${Session.getToken()}`
      }
    })
      .then(res => res.json())
      .then(data => setDoctors(Array.isArray(data) ? data : []))
      .catch(err => console.error("Doctor load error:", err));

  }, []);

  // 🔹 Save PHAD
  const handleSave = async () => {
    if (!selectedTab) {
      alert("Please Select Tab ❗");
      return;
    }

    if (!form.docID || !form.doctorName) {
      alert("DocID & Doctor Required ❗");
      return;
    }

    const payload = {

      DocID: form.docID || null,
      PatientName: form.patientName || null,
      DoctorName: form.doctorName || null,
      Vendor: form.vendor || null,
      ReportType: form.reportType || null,
      ReportSubtype: form.reportSubtype || null,
      DOB: form.dob || null,
      DOL: form.dol || null,
      Gender: form.gender || null,
      ScribedBy: form.scribedBy || null,
      Upload: form.upload || null,
      QC: form.qc || null,
      ChekedInPortal: form.chekedInPortal || null,
      TimeIn: form.timeIn || null,
      CaseType: form.caseType || null,

      WorkspaceID: Number(workspaceId),
      TabName: selectedTab,
      SheetName: sheetName
    };

    try {

      const res = await fetch(`${API_BASE_URL}/api/Cards/create-PHAD`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Session.getToken()}`
        },
        body: JSON.stringify(payload)
      });

      const result = await res.text();
      console.log("API Response:", result);

      if (!res.ok) {
        throw new Error(result);
      }

      alert("PHAD Saved Successfully ✅");

      closeModal();

    } catch (err) {
      console.error("Save Error:", err);
      alert("Save Failed ❌\n" + err.message);
    }
  };


  if (!showModal) return null;

  return (
    <>

      {/* BACKDROP */}
      <div className="modal-backdrop fade show"></div>

      {/* MODAL */}
      <div className="modal fade show" style={{ display: "block" }}>

        <div className="modal-dialog modal-dialog-centered modal-xl">

          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header bg-light">
              <h5 className="fw-bold">Add PHAD Sheet</h5>

              <button
                className="btn-close"
                onClick={closeModal}
              ></button>
            </div>


            {/* BODY */}
            <div className="modal-body">

              <div className="row g-3">

                {/* TAB */}
                <div className="col-md-6">
                  <label>Sheet Tab</label>

                  <select
                    className="form-select"
                    value={selectedTab}
                    onChange={(e) => setSelectedTab(e.target.value)}
                  >
                    <option value="">Select Tab</option>

                    {tabs.map((t, i) => (
                      <option key={i} value={t}>{t}</option>
                    ))}
                  </select>
                </div>


                {/* DOC ID */}
                <div className="col-md-6">
                  <label>Doc ID</label>

                  <input
                    className="form-control"
                    name="docID"
                    value={form.docID}
                    onChange={handleChange}
                  />
                </div>


                {/* PATIENT */}
                <div className="col-md-6">
                  <label>Patient Name</label>

                  <input
                    className="form-control"
                    name="patientName"
                    value={form.patientName}
                    onChange={handleChange}
                  />
                </div>


                {/* DOCTOR */}
               <div className="col-md-6">
      <label>Doctor Name</label>
      <select
        className="form-select"
        name="doctorName"
        value={form.doctorName}
        onChange={handleChange}
      >
        <option value="">Select Doctor</option>
        {doctors.map((d, i) => (
          <option key={i} value={d}>{d}</option>
        ))}
      </select>
    </div>


                {/* VENDOR */}
                <div className="col-md-6">
                  <label>Vendor</label>

                  <input
                    className="form-control"
                    name="vendor"
                    value={form.vendor}
                    onChange={handleChange}
                  />
                </div>


                {/* REPORT TYPE */}
                <div className="col-md-6">
                  <label>Report Type</label>

                  <input
                    className="form-control"
                    name="reportType"
                    value={form.reportType}
                    onChange={handleChange}
                  />
                </div>


                {/* REPORT SUBTYPE */}
                <div className="col-md-6">
                  <label>Report Subtype</label>

                  <input
                    className="form-control"
                    name="reportSubtype"
                    value={form.reportSubtype}
                    onChange={handleChange}
                  />
                </div>


                {/* GENDER */}
                <div className="col-md-6">
                  <label>Gender</label>

                  <select
                    className="form-select"
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>


                {/* DOB */}
                <div className="col-md-6">
                  <label>DOB</label>

                  <input
                    type="date"
                    className="form-control"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                  />
                </div>


                {/* DOL */}
                <div className="col-md-6">
                  <label>DOL</label>

                  <input
                    type="date"
                    className="form-control"
                    name="dol"
                    value={form.dol}
                    onChange={handleChange}
                  />
                </div>
<div className="col-md-6">
  <label>Scribed By</label>

  <input
    type="text"
    className="form-control"
    name="scribedBy"
    value={form.scribedBy}
    onChange={handleChange}
  />
</div>


{/* UPLOAD */}
<div className="col-md-6">
  <label>Upload</label>

  <input
    type="text"
    className="form-control"
    name="upload"
    value={form.upload}
    onChange={handleChange}
  />
</div>

                {/* QC */}
                <div className="col-md-6">
                  <label>QC</label>

                  <input
                    className="form-control"
                    name="qc"
                    value={form.qc}
                    onChange={handleChange}
                  />
                </div>

<div className="col-md-6">
  <label>Checked In Portal</label>

  <input
    type="text"
    className="form-control"
    name="chekedInPortal"
    value={form.chekedInPortal}
    onChange={handleChange}
  />
</div>
                {/* TIME IN */}
                <div className="col-md-6">
                  <label>Time In</label>

                  <input
                    type="datetime-local"
                    className="form-control"
                    name="timeIn"
                    value={form.timeIn}
                    onChange={handleChange}
                  />
                </div>


                {/* CASE TYPE */}
                <div className="col-md-6">
                  <label>Case Type</label>

                  <input
                    className="form-control"
                    name="caseType"
                    value={form.caseType}
                    onChange={handleChange}
                  />
                </div>

              </div>

            </div>


            {/* FOOTER */}
            <div className="modal-footer bg-light">

              <button
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

            </div>

          </div>

        </div>

      </div>

    </>
  );
}
